import { Button } from "../components/Button";
import { TextField } from "../components/TextField";
import { redirect, useNavigate } from "react-router-dom";
import { reset_password } from "../services/api";
import { Form } from "react-router-dom";
import mixpanel from "../services/mixpanel";




export async function ResetPasswordAction ({request}){
	try{

	const data = await request.formData();
	const formToJSON = {};
  for (const [key, value] of [...data.entries()]) {
	formToJSON[key] = value;
  }
	if(formToJSON["new_password"] === ""){
		alert("You must enter a new password");
		return;
	}
	if(formToJSON["new_password"].length < 5){
		alert("Your password must be at least 5 characters long");
		return;
	}
	if(formToJSON["confirm_password"] !== formToJSON["new_password"]){
		alert("Your passwords do not match");
		return;
	}
	const response = await reset_password(formToJSON);


	if (!response.ok) {
		// alert("Something went wrong");
		throw new Error('Network response was not ok');
	}

	const result = await response.json();

	if(result["status"]==200){
		return redirect("/dashboard");
	}else{
		alert(result["message"]);
	}
	} catch(e){

		console.log("error", e);
		alert(e);
	}
}





export default function ResetPassword (){
	const navigate = useNavigate();


	return (
		<div id="LoginScreen">

		<h1>Reset Your Password</h1>

		<main>
			<Form  method="post">
				<TextField
					label="Current Password"
					name="current_password"
					type="password"
				/>
				<TextField
					label="New Password"
					type="password"
					name="new_password"
				/>
				<TextField
					label="Confirm Password"
					type="password"
					name="confirm_password"
				/>
				<Button
				label="Change My Password"
				color="green"
				 onClick={() => {
					navigate("/dashboard");
				 }}
				/>
			</Form>

		</main>
		</div>
	)
}